import React from "react";
import { useAppSettings } from "../../../../hooks/useAppSettings.tsx";
import Layout from "../../../Layout.tsx";
import Title from "../../../Title.tsx";
import { useParams } from "react-router-dom";
import TableRiesgoOperativo from "./TableRiesgoOperativo.tsx";

type Props = {};

const RiesgoOperativo = (props: Props) => {
  useAppSettings();
  const { id } = useParams();

  return (
    <Layout>
      <Title
        baseTitle="Sucursales"
        basePath="/sucursales"
        activeTitle="Riesgo operativo"
        title="Riesgo operativo"
      />
      <div className="tab-pane fade active show" id="RiesgoOperativo">
        <div className="card border-0 m-4">
          <div className="tab-content px-3">
            <TableRiesgoOperativo />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RiesgoOperativo;
